
export const PAGES_STATIC_PAGE_SET_DATA = 'PAGES_STATIC_PAGE_SET_DATA';
export const PAGES_STATIC_PAGE_RESET_DATA = 'PAGES_STATIC_PAGE_RESET_DATA';
